// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"e4312025","453":"f09c7c94","627":"19bf4fcc","738":"f518d6b5","923":"ba186fc5"}[chunkId] + ".chunk.js";
};